import { ListItem } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BasketListViewModel } from '../../models/BasketListViewModel';
import { StyledNormalTypography } from '../../theme/StyledElements';

interface InsideMultiLevelProps {
    item: BasketListViewModel;
    active: string;
    setActive: Function;
}

export const InsideMultiLevel = ({
    item,
    active,
    setActive
}: InsideMultiLevelProps): JSX.Element => {
    const navigate = useNavigate();
    return (
        <ListItem
            button
            sx={{
                justifyContent: 'left',
                maxWidth: '275px',
                float: 'right',
                borderLeft:
                    active === item.id
                        ? '5px solid rgba(57, 74, 53, 1)'
                        : '5px solid rgba(57, 74, 53, 0.5)'
            }}
            onClick={(): void => {
                navigate(`/view-basket/${item.id}`);
                setActive(item.id);
            }}>
            <StyledNormalTypography variant="subtitle2" sx={{ marginLeft: '10px' }}>
                {item.title}
            </StyledNormalTypography>
        </ListItem>
    );
};
